"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.initMarketTrendVideos = initMarketTrendVideos;
const firebase_1 = require("./firebase");
const firestore_1 = require("firebase/firestore");
const play_svg_1 = __importDefault(require("./assets/icons/play.svg"));
const utils_1 = require("./utils");
const FIRESTORE_COLLECTION = "market_trend_videos";
const PAGE_SIZE = 9;
let lastDocument = null;
function initMarketTrendVideos(container) {
    container.innerHTML = `
      <div class="market-trend-videos">
        <div class="section-heading">Market Trend Videos</div>
        <div class="videos"></div>
        <div id="video-player" class="modal" style="display: none;">
            <div class="modal-content">
                <span class="close">&times;</span>
                <iframe id="video-frame" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
            </div>
        </div>
      </div>
    `;
    const marketTrendVideos = container.querySelector(".market-trend-videos");
    const sectionHeading = container.querySelector(".section-heading");
    const videosList = container.querySelector(".videos");
    if (!marketTrendVideos || !sectionHeading || !videosList)
        return;
    loadTrendingVideos(container);
    let isLoading = false;
    let hasMoreData = true;
    const handleScroll = () => __awaiter(this, void 0, void 0, function* () {
        const rect = videosList.getBoundingClientRect();
        const isNearBottom = rect.bottom <= window.innerHeight + 100;
        if (!isLoading && hasMoreData && isNearBottom) {
            isLoading = true;
            try {
                const hasMore = yield loadTrendingVideos(container);
                hasMoreData = hasMore;
            }
            catch (error) {
                console.error("Error loading market trend videos:", error);
            }
            finally {
                isLoading = false;
            }
        }
        // const trendRect = marketTrendVideos.getBoundingClientRect();
        // const isInViewport = trendRect.top <= 0 && trendRect.bottom > 0;
        // if (isInViewport) {
        //     sectionHeading.classList.add("sticky");
        // } else {
        //     sectionHeading.classList.remove("sticky");
        // }
    });
    const throttle = (func, limit) => {
        let lastCall = 0;
        return (...args) => {
            const now = Date.now();
            if (now - lastCall >= limit) {
                lastCall = now;
                func(...args);
            }
        };
    };
    window.addEventListener("scroll", throttle(handleScroll, 200));
}
function loadTrendingVideos(container) {
    return __awaiter(this, void 0, void 0, function* () {
        const videosList = container.querySelector(".videos");
        if (!videosList)
            return false;
        try {
            const db = yield (0, firebase_1.getFirestoreInstance)();
            let videosQuery = (0, firestore_1.query)((0, firestore_1.collection)(db, FIRESTORE_COLLECTION), (0, firestore_1.orderBy)("date", "desc"), (0, firestore_1.limit)(PAGE_SIZE));
            if (lastDocument) {
                videosQuery = (0, firestore_1.query)(videosQuery, (0, firestore_1.startAfter)(lastDocument));
            }
            const querySnapshot = yield (0, firestore_1.getDocs)(videosQuery);
            if (querySnapshot.empty) {
                console.log("No more videos to load");
                return false;
            }
            querySnapshot.forEach((doc) => {
                var _a, _b, _c;
                const videoData = doc.data();
                console.log("videoData - ", videoData);
                const videoElement = document.createElement("div");
                videoElement.classList.add("video");
                videoElement.setAttribute("data-video-url", videoData.video_link);
                videoElement.innerHTML = `
                <div class="thumbnail" style="background-image: url('${videoData.img_link}');">
                    <div class="thumbnail-overlay" style="">
                        <div class="play-icon">
                            <img src="${play_svg_1.default}" alt="Play Video" />
                        </div>
                    </div>
                </div>
                <div class="date">${(0, utils_1.formatDate)((_a = videoData.date) === null || _a === void 0 ? void 0 : _a.trim())}</div>
                <div class="title">${(_b = videoData.headline) === null || _b === void 0 ? void 0 : _b.trim()}</div>
                <div class="source">Source: <span>${(_c = videoData.source) === null || _c === void 0 ? void 0 : _c.trim()}</span></div>
            `;
                videosList.appendChild(videoElement);
            });
            videosList.addEventListener("click", (event) => {
                const target = event.target;
                if (target.closest(".play-icon")) {
                    const videoElement = target.closest(".video");
                    if (videoElement) {
                        const videoUrl = videoElement.getAttribute("data-video-url");
                        if (videoUrl) {
                            showVideoModal(videoUrl);
                        }
                    }
                }
            });
            lastDocument = querySnapshot.docs[querySnapshot.docs.length - 1];
            return true;
        }
        catch (error) {
            console.error("Error loading trending videos:", error);
            return false;
        }
    });
}
function showVideoModal(videoUrl) {
    const modal = document.querySelector("#video-player");
    const iframe = modal.querySelector("#video-frame");
    const closeButton = modal.querySelector(".close");
    if (!modal || !iframe || !closeButton)
        return;
    iframe.src = videoUrl;
    modal.style.display = "flex";
    closeButton.addEventListener("click", () => {
        modal.style.display = "none";
        iframe.src = "";
    });
    modal.addEventListener("click", (event) => {
        if (event.target === modal) {
            modal.style.display = "none";
            iframe.src = "";
        }
    });
}
